import { Assessment as ReportIcon, BuildRounded, History as AuditIcon, Notifications as NotificationsIcon } from '@mui/icons-material';
import type { NavItemType } from '../types/menu';

const icons = {
  system: BuildRounded,
  reports: ReportIcon,
  audit: AuditIcon,
  notifications: NotificationsIcon,
};

const system: NavItemType = {
  id: 'group-system',
  title: 'System',
  type: 'group',
  icon: icons.system,
  children: [
    {
      id: 'audit-logs',
      title: 'Audit Logs',
      type: 'item',
      url: '/audit-logs',
      color: 'primary',
      icon: icons.audit,
      permissionModule: 'audit',
    },
    {
      id: 'notifications',
      title: 'Notification',
      type: 'item',
      url: '/notifications',
      color: 'primary',
      icon: icons.notifications,
      permissionModule: 'notification',
    },
  ],
  color: undefined,
  url: undefined
};

export default system;
